import React, { useEffect, useState, useRef } from "react";
import Headers from "@/components/Headers";
import { Split_Detail } from "@/constants/breadcrumb";
import Search from "./Search";
import Content from "./Content";
import { shareCompanyDetail } from "@/api/business";
import { useHistory,useParams } from "react-router-dom";
import { Button } from "antd";
import qs from 'qs';
import "./index.scss";

const SplitPage = () => {
  const containerRef = useRef(null);

  const history = useHistory(); 
  
  const [otherParams,setOtherParams]=useState({}); 

  const { id } = useParams();
 
  const [dataSource, setDataSource] = useState([]);

  const [page, setPage] = useState({
    pageNum: 1,
    pageSize: 10,
    total: 0,
  });

  const fetchList = () => {
    shareCompanyDetail({
      pageNum: page.pageNum,
      pageSize: page.pageSize,
      companyId:id,
      ...otherParams
    }).then((res) => {
      if (res.success) {
        setDataSource(res.data.searchResult.list);
        setPage({ ...page, total: res.data.searchResult.total });
      }
    });
  };
  useEffect(() => {
    fetchList();
  }, [page.pageSize, page.pageNum,otherParams]);

  const handleTableChange = (pageNum, pageSize) => {
    setPage({ ...page, pageNum, pageSize });
  };

  const handleShowSizeChange = (pageNum, pageSize) => {
    setPage({ ...page, pageNum: 1, pageSize });
  };

  const handleSearch=(values)=>{
    if(!values.type) delete values.type;
    setOtherParams({...values})
    setPage({ ...page, pageNum: 1 });
  }
 
  const handleExport=()=>{
    const { beginTime, endTime, type } = otherParams;
    let searchObj={
      accessToken:JSON.parse(sessionStorage.getItem("loginInfo")).accessToken,
      companyId:id,
    }
    if(type){
      searchObj.type=type;
    }
    if(beginTime){
      searchObj.beginTime=beginTime;
    }
    if(endTime){
      searchObj.endTime=endTime;
    }
    window.location.href =
      process.env.REACT_APP_API_PREFIX +
      `try/share/list/export?${qs.stringify(searchObj)}`;
  }

  return (
    <div className="container business-page" ref={containerRef}>
      <Headers BreadCrumbData={Split_Detail}></Headers>

      <div className="pt-24 pl-24 pr-24">
        <Button onClick={() => history.push("/page/business/split")}>
          返回
        </Button>
        <Search onSearch={handleSearch} onExport={handleExport}/>
        <Content
          dataSource={dataSource}
          page={page}
          onTableChange={handleTableChange}
          onShowSizeChange={handleShowSizeChange}
        />
      </div>
    </div>
  );
};
export default SplitPage;
